/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CurrentPeakPowerFromGridResponse } from '../../models/current-peak-power-from-grid-response';

export interface GetCurrentPeakPowerFromGrid$Params {
  location_id: string;
  current_month_start?: string;
  planning_start?: string;
}

export function getCurrentPeakPowerFromGrid(http: HttpClient, rootUrl: string, params: GetCurrentPeakPowerFromGrid$Params, context?: HttpContext): Observable<StrictHttpResponse<CurrentPeakPowerFromGridResponse>> {
  const rb = new RequestBuilder(rootUrl, getCurrentPeakPowerFromGrid.PATH, 'get');
  if (params) {
    rb.path('location_id', params.location_id, {});
    rb.query('current_month_start', params.current_month_start, {});
    rb.query('planning_start', params.planning_start, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CurrentPeakPowerFromGridResponse>;
    })
  );
}

getCurrentPeakPowerFromGrid.PATH = '/locations/{location_id}/energy-readings/current-peak-power-from-grid';
